import React from 'react';
import { withRouter } from 'react-router';
import CategoriesPage from '@/components/categories';

const Categories = () => (
  <CategoriesPage />
);

export default withRouter(Categories);
